import React from "react";
import { downloadFile, getFileExtension } from "@/utilities/functions";
import { getAreaComponents, getMagnoliaHost } from "@/utilities/functions/magnoliaUtils";
import { ContentLink, Typography } from "br2s-ui-componentlibrary_r2_02";
import { SystemIcon } from 'br2s-ui-componentlibrary_r2_02/dist/foundation/assets/system-icon';
import './FileSelector.scss'

interface FileSelectorDef {
    fileLink: any[]
    label: string | undefined
}

const FileSelector = ({ fileLink=[], label=undefined }: FileSelectorDef) => {
    const mgnlHost = getMagnoliaHost();
    const allFileLink = getAreaComponents(fileLink) || []
    const getSize = (size: number) => `${Math.ceil(size/1024)} KB`
    const getTitle = (fileInfo: any) => typeof fileInfo.fileLabel !== 'undefined'  ? 
        fileInfo.fileLabel : fileInfo.file['@name']
    const getFilePath = (url: string) => `${mgnlHost}${url}`;
    return (
        <div className="file-selector-container">
            {label && <Typography label={label} type='base' />}
            <div className="content-link-container">
                {allFileLink.map((item: any, index: number) => (
                    item.file['@link'] && (
                        <div className="content-link-row" key={`content-link-row-${index + 1}`}>
                            <ContentLink
                                id={`cmp-content-link-${index + 1}`}
                                iconClass={SystemIcon.ActionDownload}
                                tag="button"
                                label={getTitle(item)}
                                onClick={() => downloadFile(getFilePath(item.file['@link']), getFilePath(item.file['@link']))}
                                isWithLabel={true}
                                secondaryLabel={`${getFileExtension(item.file.metadata.fileName)} (${getSize(item.file.metadata.fileSize)})`}
                            />
                        </div>
                    )
                ))}
            </div>
        </div>
    )
}

export default FileSelector;